import type { QueryClient, QueryKey } from "@tanstack/react-query";

export type OptimisticPatch = {
  key: QueryKey;
  update: (current: any) => unknown;
};

export type OptimisticSnapshot = {
  rollback: () => void;
};

export function applyOptimisticPatches(qc: QueryClient, patches: OptimisticPatch[]): OptimisticSnapshot {
  const previous = patches.map((patch) => ({ key: patch.key, value: qc.getQueryData(patch.key) }));
  for (const patch of patches) {
    const current = qc.getQueryData(patch.key);
    const next = patch.update(current);
    qc.setQueryData(patch.key, next);
  }
  return {
    rollback: () => {
      for (const snap of previous) {
        qc.setQueryData(snap.key, snap.value);
      }
    },
  };
}
